export default "__VITE_ASSET__Cheax91O__"